// extracted by mini-css-extract-plugin
export default {"template-info":"tch1","templateInfo":"tch1","info":"hsrG","description":"sAQ_","description-box":"fgSL","descriptionBox":"fgSL","logo":"wkrO"};